import { useRef } from 'react'
import { MdAttachFile } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { DropzoneRef } from 'react-dropzone'
import type { TFileType } from '~/types/application-version'
import type { IFileUploaded } from '~/types/file'

import Button from '~/components/Buttons/Button'
import FilePreview from '~/components/FilePreview'
import UploadFileInput from '~/components/Inputs/UploadFileInput'

import './styles.scss'

interface Props {
  fileType: TFileType
  files: IFileUploaded[]
  onDrop: (files: IFileUploaded[]) => void
  onRemove: (fileType: TFileType, id: string) => void
}

const UploadFilesBlock = ({ files, fileType, onDrop, onRemove }: Props): ReactElement => {
  /** Local state */

  const dropzoneRef = useRef<DropzoneRef>(null)

  /** Handlers */

  const handleUpload = () => dropzoneRef.current && dropzoneRef.current.open()

  const handleRemove = (id: string) => onRemove(fileType, id)

  /** Render */

  return (
    <div className="upload-files-block-component">
      <UploadFileInput
        accept={{ 'audio/*': [], 'image/*': [], 'video/*': [] }}
        dropzoneRef={dropzoneRef}
        noVisibleZone
        onDrop={onDrop}
      />
      {files.length > 0 ? (
        <div className="preview-wrapper">
          {files.map(({ download_url, id, mime_type, name }) => (
            <FilePreview
              key={id}
              mimeType={mime_type}
              name={name}
              onRemove={() => handleRemove(id)}
              src={download_url}
              withQualityIdentifier={false}
            />
          ))}
        </div>
      ) : null}
      <Button className="upload-file-button" ghost onClick={handleUpload}>
        <MdAttachFile color="#ff5301" size={20} />
      </Button>
    </div>
  )
}

export default UploadFilesBlock
